export enum eSettings {
  SETTINGS = 'SETTINGS',
}
